module.exports = __webpack_public_path__ + "images/emoji/dizzy.92ceadf67c74b5c45f79.png";